import React from "react";
import articleSeparator from "../../../../../img/article-separator.png";
import "./style.scss";

const Index = () => {
  return (
    <div className="article-header-container">
      <div className="inner-article-header-container">
        <div className="fader" />
        <div className="header-content">
          <small className="article-type">Gjesteinnlegg</small>
          <h5 className="article-title">
            Slik brukte B&B Marketing Leadfind for å skaffe nye kunder og øke
            salget
          </h5>
        </div>
        <img className="header-separator" src={articleSeparator} />
      </div>
    </div>
  );
};

export default Index;
